import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./components/Pages/HomePage";
import "typeface-domine";
import "typeface-inter";
import WTM from "./components/Pages/Cases/WTM";
import Kaktu from "./components/Pages/Cases/Kaktu";
import Oreksi from "./components/Pages/Cases/Oreksi";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/wtm" element={<WTM />} />
        <Route path="/kaktu" element={<Kaktu />} />
        <Route path="/oreksi" element={<Oreksi/>} />
      </Routes>
    </Router>
  );
}

export default App;
